import styled, { css } from 'styled-components';
import { Modal } from 'react-bootstrap';
import { getColor } from '@karma/components/colors';
import { MAX_TABLET_WIDTH } from 'consts/common';
import { BREAK_POINT_SMALL_TO_LARGE } from 'consts/UI';

const modalW400 = css`
  & .modal-dialog {
    position: absolute;
    max-width: 400px;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) !important;
    margin: 0;
  }

  & .modal-content {
    border-radius: 10px;
    background: ${getColor('neutral6')};
  }
`;

export const BootstrapModal = styled(Modal)`
  color: ${getColor('primary1')};

  .modal-dialog {
    width: 470px;
    margin-top: 90px;

    @media (max-width: 470px) {
      width: calc(100% - 1rem);
      margin-top: 90px;
    }
  }

  & .modal-content {
    min-height: 200px;
    padding: 40px;
    border: none;
    border-radius: 20px;
    box-shadow: none;
  }
`;

export const MixinModalMyItems = styled(Modal)`
  ${modalW400}
`;

export const MixinModalUnderMaintenance = styled(Modal)`
  ${modalW400};
`;

export const MixinModalItemSaved = styled(Modal)`
  ${modalW400}
`;

export const MixinModalPartnershipsContact = styled(Modal)`
  & .modal-dialog {
    width: auto;
    max-width: 540px;
    margin-left: auto;
    margin-right: auto;
    @media (max-width: ${MAX_TABLET_WIDTH}px) {
      width: auto;
      max-width: 335px;
    }
  }

  & .modal-content {
    padding: 40px 70px;
    @media (max-width: ${MAX_TABLET_WIDTH}px) {
      padding: 20px;
    }
  }
`;

// Spacing constants for Hubspot form modal
const SPACING_HUBSPOT = {
  MODAL_PADDING: '48px',
  MODAL_PADDING_MOBILE: '24px',
  MODAL_CLOSE_OFFSET: '24px',
};

// Breakpoints for Hubspot form modal
const BREAKPOINTS_HUBSPOT = {
  MOBILE: '576px',
};

export const MixinModalPartnershipsHubspotForm = styled(Modal)`
  .modal-dialog {
    max-width: 672px;
    width: 100%;
    margin: 0 auto;
    top: 90px;

    @media (max-width: ${BREAKPOINTS_HUBSPOT.MOBILE}) {
      width: auto;
      top: 10px;
    }
  }

  .modal-content {
    width: 100%;
    padding: ${SPACING_HUBSPOT.MODAL_PADDING};

    @media (max-width: ${BREAKPOINTS_HUBSPOT.MOBILE}) {
      padding: ${SPACING_HUBSPOT.MODAL_PADDING_MOBILE};
    }
  }

  .modal-content button[name='close'] {
    top: ${SPACING_HUBSPOT.MODAL_CLOSE_OFFSET};
    right: ${SPACING_HUBSPOT.MODAL_CLOSE_OFFSET};

    svg {
      /* Scale SVG to fit 20px if original viewBox is 0 0 25 25 */
      /* This effectively changes the visible area similar to viewBox */
      transform: scale(0.8);
      transform-origin: center;
      path {
        fill: ${getColor('color13')};
      }
    }
  }
`;

export const MixinModalLogInLanding = styled(Modal)`
  & .modal-dialog {
    width: 480px;
  }

  & .modal-content {
    padding: 40px;
  }

  & .modal-body {
    display: flex;
    flex-direction: column;
  }
`;

export const MixinModalKarmaEarnGameGenres = styled(Modal)`
  text-align: center;
  white-space: pre-line;

  ${modalW400};

  & .modal-dialog {
    width: calc(100% - 20px);
    max-width: 510px;
  }

  .modal-content {
    padding: 20px 12px;

    @media (min-width: ${BREAK_POINT_SMALL_TO_LARGE}px) {
      padding: 40px 24px;
    }
  }
`;

export const MixinModalKarmaEarnRedirectLoading = styled(Modal)`
  .modal-dialog {
    position: absolute;
    max-width: 470px;
    width: 60%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) !important;
    margin: 0;
  }

  .modal-content {
    background: transparent;
    padding: 0;
    height: auto;
    min-height: initial;
    max-height: initial;
  }
`;

export const MixinModalKarmaEarnRedirectError = styled(Modal)`
  ${modalW400};

  .modal-dialog {
    max-width: 335px;
  }

  .modal-content {
    padding: 40px 24px;
  }
`;

export const MixinModalKarmaEarn = styled(Modal)`
  ${modalW400};

  .modal-content {
    padding: 40px 24px;
  }
`;

export const MixinModalBonusWelcome = styled(Modal)`
  ${modalW400}
`;

export const MixinModalOutdatedOnboarding = styled(Modal)`
  ${modalW400}
`;

export const MixinModalWallet = styled(Modal)`
  text-align: center;
  white-space: pre-line;

  ${modalW400};

  & .modal-dialog {
    width: calc(100% - 20px);
  }

  .modal-content {
    padding: 40px 24px;
  }
`;

export const MixinModalVideoHowToSave = styled(Modal)`
  & .modal-dialog {
    width: 80%;
    max-width: 1200px;
    margin-top: 50px;

    @media (min-aspect-ratio: 5/3) and (max-width: 1500px) {
      margin-top: 30px;
      width: 70%;
    }

    button[name='close'] {
      top: 10px;
      right: 10px;
    }
  }
`;

export const MixinModalDoNotSellMyInfo = styled(Modal)`
  & .modal-dialog {
    width: auto;
    max-width: 530px;
  }

  & .modal-content {
    padding: 80px;
  }

  & h3[name='title'] {
    margin-bottom: 40px;
    font-size: 30px;
    line-height: 1.33;

    @media (max-width: 767px) {
      max-width: 90%;
    }
  }
`;
export const MixinModalChangeLanguage = styled(Modal)`
  & .modal-dialog {
    width: 480px;
  }
  & h3[name='title'] {
    margin-bottom: 40px;
  }
`;

export const MixinModalProduct = styled(Modal)`
  & .modal-dialog {
    min-width: 780px;
  }

  & .modal-content {
    padding: 40px;
  }
`;

export const MixinModalAuthenticate = styled(Modal)`
  & .modal-dialog {
    width: 840px;
    max-width: 100%;
  }

  & .modal-content {
    padding: 0;
  }
`;

export const MixinModalChatWithUs = styled(Modal)`
  & .modal-dialog {
    width: 816px;
    max-width: 100%;
  }

  & .modal-content {
    padding: 0;
  }
`;

export const MixinModalAuthenticateSmall = styled(Modal)`
  & .modal-dialog {
    width: 500px;
    max-width: 100%;
  }

  & .modal-content {
    padding: 0;
  }
`;

export const MixinModalResetPassword = styled(Modal)`
  & .modal-dialog {
    width: 840px;
    max-width: 100%;

    @media (max-width: 767px) {
      width: 96%;
    }
  }

  & .modal-content {
    padding: 0;
  }
`;

export const MixinModalStoreInfo = styled(Modal)`
  overflow: hidden !important;

  & .modal {
    padding: 0;
  }

  & .modal-dialog {
    width: 1100px;
    max-width: 90%;
    height: 100%;
    padding: 30px 0;
    margin: 0 auto;
    display: flex;
    align-items: center;
  }

  & .modal-content {
    background: ${getColor('neutral6')};
    max-height: 90vh;
    height: fit-content;
    overflow: hidden;
    padding: 0;
  }

  .modal-body {
    overflow-y: auto;
    overflow-x: hidden;
    padding: 40px;

    &::-webkit-scrollbar {
      border-radius: 8px;
      width: 4px;
      background: transparent;

      &:hover {
        width: 8px;
        background: transparent;
      }
    }

    &::-webkit-scrollbar-track {
      border-radius: 50%;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 8px;
      background: ${getColor('neutral4')};
    }

    &::-webkit-scrollbar-thumb:hover {
      background: ${getColor('neutral4')};
    }
  }
`;

export const MixinModalManageStores = styled(Modal)`
  & .modal-dialog {
    width: 640px;
    max-width: 100%;
  }

  & .modal-content {
    padding: 32px;
    background: ${getColor('neutral6')};
  }
`;

export const MixinModalLoyaltyForm = styled(Modal)`
  & .modal-dialog {
    width: 90%;
    max-width: 1000px;

    @media (max-width: 470px) {
      margin: 20px auto;
    }
  }

  & .modal-content {
    padding: 10px;
  }
`;
